import {createApp} from 'vue'
import App from './App.vue'

import './index.css'

let nodes = document.querySelectorAll('.promille')
for (var i = 0; i < nodes.length; ++i) {
    createApp(App).mount(nodes[i]);
}
